// extracted by css-extract-rspack-plugin
export default {"cls1":"TransactionalPricingModal-cls1_2Ks","cls2":"TransactionalPricingModal-cls2_rN6 TransactionalPricingModal-cls1_2Ks"};